import React, { ReactElement, PropsWithChildren } from 'react';
import Link from 'next/link';
import { TThreadPreviewProperties } from './thread-preview.types';
import {
    StyledAddressAddress,
    StyledDateTime,
    StyledMessagePreviewDiv,
    StyledThreadPreviewWrapper,
    StyledNameDateDiv,
    StyledNameDiv,
    StyledRowTwoDiv,
    StyledUnreadIndicator,
    StyledAnchor,
} from './thread-preview.styled';

export function ThreadPreview({
    name,
    address,
    time,
    active,
    unread,
    children,
    href,
}: PropsWithChildren<TThreadPreviewProperties>): ReactElement {
    return (
        <Link href={href} passHref>
            <StyledAnchor>
                <StyledThreadPreviewWrapper
                    active={active}
                    data-testid="thread-preview-wrapper"
                >
                    <StyledNameDateDiv>
                        <StyledNameDiv
                            active={active}
                            unread={unread}
                            data-hj-suppress
                        >
                            {name}
                        </StyledNameDiv>
                        <StyledDateTime active={active} unread={unread}>
                            {time}
                        </StyledDateTime>{' '}
                    </StyledNameDateDiv>
                    <StyledRowTwoDiv>
                        {address ? (
                            <StyledAddressAddress
                                active={active}
                                unread={unread}
                                data-testid="address"
                            >
                                {address}
                            </StyledAddressAddress>
                        ) : (
                            <StyledMessagePreviewDiv
                                active={active}
                                data-hj-suppress
                            >
                                {children}
                            </StyledMessagePreviewDiv>
                        )}
                        <StyledUnreadIndicator
                            unread={unread}
                            data-testid="unread-indicator-wrapper"
                        >
                            <svg
                                viewBox="0 0 100 100"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16px"
                                height="16px"
                                fill="#8a2d87"
                            >
                                <circle cx="50" cy="50" r="50" />
                            </svg>
                        </StyledUnreadIndicator>
                    </StyledRowTwoDiv>

                    {address && (
                        <StyledMessagePreviewDiv active={active}>
                            {children}
                        </StyledMessagePreviewDiv>
                    )}
                </StyledThreadPreviewWrapper>
            </StyledAnchor>
        </Link>
    );
}
